<template>
  <div>
    <v-progress-linear
      :active="statusOfButton"
      height="3"
      :indeterminate="true"
    />
    <v-layout row class="align-center layout px-4 pt-4 app--page-header">
      <div class="page-header-left">
        <h3 class="pr-3">
          {{ $tc(`models.${title}`) }}
        </h3>
      </div>
      <v-breadcrumbs
        :items="[
          { text: 'home', to: { name: 'dashboard' }, icon: true },
          ...breadcrumbs.map((item) => ({ text: $tc(`models.${item}`) })),
        ]"
        divider="-"
      >
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item :to="item.to">
            <v-icon larg v-if="item.icon">{{ item.text }}</v-icon>
            <span v-else>
              {{ item.text }}
            </span>
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <v-spacer />
      <div class="page-header-right">
        <v-btn icon :disabled="statusOfButton" @click="changeStatus(true)">
          <v-icon class="text--secondary"> refresh </v-icon>
        </v-btn>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import menu from '../../api/menu'
export default {
  data() {
    return {
      title: '',
    }
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
    breadcrumbs: function () {
      let breadcrumbs = []
      menu.forEach((item) => {
        if (item.items) {
          let child = item.items.find((i) => {
            return i.component === this.$route.name
          })
          if (child) {
            breadcrumbs.push(item.title)
            breadcrumbs.push(child.title)
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.title = child.title
          }
        } else {
          if (item.name === this.$route.name) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.title = item.title
            breadcrumbs.push(item.title)
          }
        }
      })
      return breadcrumbs
    },
  },
  methods: {
    ...mapActions({
      changeStatus: 'events/setStatus',
    }),
  },
}
</script>
<style scoped>
.v-progress-linear {
  margin: 0.2rem 0;
}
</style>
